import { createAction } from '@reduxjs/toolkit';
import { api, handleApiErrors } from 'lib/src/utils/api';
import { ChallengeTag } from 'lib/src/types/shared/ChallengeTag';
import { AppDispatch } from 'src/redux/store';

export const fetchAllBusinessTagsRequest = createAction('fetchAllBusinessTagsRequest');
export const fetchAllBusinessTagsSuccess = createAction<ChallengeTag[]>(
    'fetchAllBusinessTagsSuccess',
);
export const fetchAllBusinessTagsFailure = createAction('fetchAllBusinessTagsFailure');

export const fetchAllBusinessTags = () => async (dispatch: AppDispatch): Promise<void> => {
    dispatch(fetchAllBusinessTagsRequest());
    try {
        const { data } = await api.get<ChallengeTag[]>('admin/challengeTags/business');
        dispatch(fetchAllBusinessTagsSuccess(data));
    } catch (e) {
        handleApiErrors(dispatch, fetchAllBusinessTagsFailure, e);
    }
};
